/**
 * Plus and minus around a number field.
 *
 * The field itself is a real <input type="number">, so it is typeable, valid
 * without this script, and submits with the form regardless. The buttons only
 * save a phone user from a spinner too small to hit.
 */
class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    if (!this.input) return;

    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const button = event.target.closest('[data-quantity-step]');
    if (!button) return;

    const step = Number(button.dataset.quantityStep);
    const min = Number(this.input.min) || 1;
    const next = Math.max(min, (Number(this.input.value) || min) + step);

    if (next === Number(this.input.value)) return;
    this.input.value = next;
    // Anything watching the field — the buy button, a price line — listens for
    // change, and a programmatic value assignment does not fire one.
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

customElements.define('quantity-input', QuantityInput);
